import React, { useState } from 'react'
import { Mail, Users } from 'lucide-react'
import { Avatar, AvatarImage, AvatarFallback } from 'components/ui/avatar'
import CommunicationPartnersCN from 'components/popups/CommunicationPartnersCN'
import { useChat } from 'features/Chat'
import usePartnerProfileDialog from 'features/Partners/hooks/usePartnerProfileDialog'

function SidebarPortfolioPartners({ assetOwner, assetName, assetPartners, userId }) {
	const { state } = useChat()
	const [openPopup, setOpenPopup] = useState(false)
	const { openPartner, partnerDialog } = usePartnerProfileDialog()
	const owner = [
		{
			id: assetOwner._id,
			image: assetOwner.image,
			name: assetOwner.name,
			email: assetOwner.email,
			title: assetOwner.title,
			company: assetOwner.company,
			owner: true,
		},
	]

	// Optional-chained throughout: a partner entry whose partnerUserId has not
	// been populated would otherwise throw and take the whole sidebar with it.
	const partners = (assetPartners || [])
		.filter(item => item?.partnerUserId?._id)
		.map(item => ({
			id: item.partnerUserId._id,
			image: item.partnerUserId.image,
			name: item.partnerUserId.name,
			email: item.partnerUserId.email,
			title: item.partnerUserId.title,
			company: item.partnerUserId.company,
			owner: false,
			emailOption: '',
		}))

	const allPartners = [...owner, ...partners]
	const isEmpty = allPartners?.length === 0

	return (
		<>
			<div className="flex flex-col">
				<div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
					<span className="flex items-center gap-2 text-gray-600 text-base font-semibold">
						<Users className="w-4 h-4" /> Portfolio Partners
					</span>
					<button
						type="button"
						onClick={() => setOpenPopup(true)}
						className="text-gray-500 hover:text-gray-700 bg-transparent border-none cursor-pointer p-0"
						aria-label="Partner Communications"
					>
						<Mail className="w-5 h-5" />
					</button>
				</div>
				<div className="overflow-y-auto max-h-[240px]">
					{isEmpty ? (
						<div className="flex items-center justify-center p-4">
							<h3 className="text-[#0080fe] opacity-30 text-sm font-light text-center">
								No Partners
							</h3>
						</div>
					) : (
						<div>
							{allPartners.map((partner, index) => (
								<button
									key={index}
									type="button"
									// Your own row (you as originator) has no profile to open.
									disabled={String(partner.id) === String(userId)}
									onClick={() => openPartner(partner.id, partner)}
									className="w-full flex items-center px-4 py-2 text-left hover:bg-gray-50 disabled:hover:bg-transparent disabled:cursor-default"
								>
									<Avatar className="h-9 w-9 mr-3 shrink-0">
										<AvatarImage src={partner.image} />
										<AvatarFallback />
									</Avatar>
									<div className="flex-1 min-w-0">
										<div className="text-sm text-gray-900 truncate">{partner.name}</div>
										<div className="text-xs text-gray-500 truncate">{`${partner.title || ''}${partner.company ? ` - ${partner.company}` : ''}${partner.owner ? ' (portfolio originator)' : ''}`}</div>
									</div>
								</button>
							))}
						</div>
					)}
				</div>
			</div>
			<CommunicationPartnersCN
				open={openPopup}
				onClose={() => setOpenPopup(false)}
				partners={allPartners}
				assetName={assetName}
			/>
			{partnerDialog}
		</>
	)
}

export default SidebarPortfolioPartners
